import React from "react";
import { Skeleton } from "antd";
import { generateGUID } from "../../../utils/MainHelper";

function TableRowSkeleton({
    height = "8mm",
    noNum,
    noCheckBox,
    cols
}) {
    return (
        <div
            className="d-flex gap-5p"
            style={{
                height, width: "100%"
            }}
        >
            {!noCheckBox && (
                <Skeleton.Avatar
                    active
                    shape="square"
                    style={{
                        height: "100%", width: "5mm"
                    }}
                />
            ) }

            {!noNum && (
                <Skeleton.Avatar
                    active
                    shape="square"
                    style={{
                        height: "100%", width: "20mm"
                    }}
                />
            ) }
            {cols.split("").map(() => (
                <Skeleton.Avatar
                    key={generateGUID()}
                    className="flex-1"
                    active
                    shape="square"
                    style={{
                        height: "100%", width: "100%"
                    }}
                />
            ))}
        </div>
    );
}
function TableSkeleton({
    noNum = false,
    noCheckBox = true,
    numCols = 2
}) {
    let cols = "";

    for (let i = 0; i < numCols; i++) {
        cols += "|";
    }
    return (
        <div
            className="d-flex-col gap-1"
            style={{
                height: "100%", width: "100%"
            }}
        >
            <TableRowSkeleton height="10mm" cols={cols} noNum={noNum} noCheckBox={noCheckBox} />
            <div
                className="d-flex-col gap-5p"
                style={{
                    height: "calc(100% - 10mm)", width: "100%"
                }}
            >
                {
                    "111111111111".split("").map(() => (
                        <TableRowSkeleton cols={cols} noNum={noNum} noCheckBox={noCheckBox} key={generateGUID()} />
                    ))
                }
            </div>
        </div>
    );
}

export default TableSkeleton;
